/**
 * @description Formats a data object using the given replacer and an optional formatter.
 */
export function format(data, { formatter }) {
    return formatter(data);
}
export function defineFormatter({ format, }) {
    return ({ exclude, format: formatOverride, }) => (data) => {
        const formatted = format(data);
        if (exclude) {
            for (const key of exclude) {
                delete formatted[key];
            }
        }
        return {
            ...formatted,
            ...formatOverride?.(data),
        };
    };
}
//# sourceMappingURL=format.js.map